import React, { useContext, useState, useEffect, useRef } from "react";
import { Routes, Route, Navigate, useNavigate } from "react-router-dom";
import { redirect } from "react-router-dom";
import { GlobalState } from "../GlobalState";

import NotFound404 from "../pages/notFound404";
import Events from "../pages/Events";
import LoginUser from "./LoginUser";
import Loading from "./Loading";
import LoginPhone from "./LoginPhone";
import Header from "./header/Header";
import Footer from "./footer/Footer";
import TeamPage from "../pages/TeamPage";
import AdminPage from "../pages/AdminPage";
import Callback from "../pages/callback";
import Loginmyu from "./Loginmyu";
import Login from "./LoginUser";
import EventTet2026 from "../pages/EventTet2026";
// import LoginPhone from "./LoginPhone";

function Router() {
  const state = useContext(GlobalState);
  const [islogged] = state.isAuthenticated;
  const [isAdmin] = state.isAdmin;
  const [checked, setChecked] = useState(false);
  const [minHeight, setMinHeight] = useState("100vh");

  useEffect(() => {
    const updateHeight = () => {
      const footerHeight = footerRef.current?.offsetHeight || 0;
      setMinHeight(`calc(100vh - ${footerHeight}px)`);
    };

    updateHeight(); // tính lần đầu
    window.addEventListener("resize", updateHeight); // tính lại khi resize

    return () => window.removeEventListener("resize", updateHeight);
  }, []);

  // const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    setChecked((sessionStorage.getItem("islogged") === "true"));
  }, [islogged]);

  const footerRef = useRef(null);

  return (
    <div className="flex flex-col min-h-screen font-sans ">
      <div style={{ minHeight }} className={`flex-1`}>
        <Routes>
          {" "}
          {/* ✅ Route công khai, không cần đăng nhập */}
          <Route path="/" element={<RedirectBasedOnLogin />} />
          <Route path="/myu" element={<Loginmyu />} />
          <Route path="/phone" element={<LoginPhone />} />
          <Route path="/callback" element={<Callback />} />
          {/* ✅ Route cần đăng nhập */}
          {checked ? (
            <>
              {/* Route cho user */}
              <Route path="user/">
                <Route path="events/" element={<EventTet2026 />} />
                <Route path="teams/:name" element={<TeamPage />} />
              </Route>
              <Route path="admin/" element={<AdminPage />} />
              {/* <Route path="*" element={<Navigate to="/user/events/" />} /> */}
            </>
          ) : (
            <>
              {/* Có thể hiển thị login ở bất kỳ route admin nào khi chưa đăng nhập */}
              <Route path="*" element={<LoginUser />} />
              {/* <Route path="*" element={<Login />} /> */}
            </>
          )}
        </Routes>
      </div>
      <div ref={footerRef} className={` w-full`}>
        {/* <Footer></Footer> */}
      </div>
    </div>
  );
}
const RedirectBasedOnLogin = () => {
  const isLogged = sessionStorage.getItem("islogged") === "true";
  return isLogged ? <Navigate to="/user/events/" /> : <LoginUser />;
};
export default Router;
